export const sixSteps = [
  {
    id: 1,
    title: 'Подай заявку на стажировку',
    text: 'С 27 февраля по 20 марта 2026 г. Не забудь прикрепить резюме и мотивационное письмо.'
  },
  {
    id: 2,
    title: 'Пройди онлайн-тестирование',
    text: 'С 27 по 31 марта 2026 г. '
  },
  {
    id: 3,
    title: 'Дождись результатов',
    text: 'Мы сообщим тебе о них по электронной почте.'
  },
  {
    id: 4,
    title: 'Пообщайся с командой',
    text: 'С 6 по 30 апреля 2026 г.'
  },
  {
    id: 5,
    title: 'Дождись результатов',
    text: 'До 8 мая 2026 г.'
  },
  {
    id: 6,
    title: 'Приезжай на стажировку',
    text: 'В п. Вольгинский или на площадку Алабушево (г. Зеленоград)'
  }
]
